import React from 'react';
import { 
  Users,
  MessageCircle,
  Heart,
  Share2,
  MessagesSquare
} from 'lucide-react';

const DiscussionCard = ({ discussion }) => (
  <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all">
    <div className="flex items-start gap-4">
      <img 
        src={discussion.author.avatar} 
        alt={discussion.author.name}
        className="w-10 h-10 rounded-full"
      />
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <h3 className="font-medium text-gray-900">{discussion.author.name}</h3>
          <span className="text-sm text-navy-600 bg-navy-50 px-2 py-0.5 rounded-full">
            {discussion.author.role}
          </span>
          <span className="text-sm text-gray-500">• {discussion.timestamp}</span>
        </div>
        <h2 className="text-lg font-bold text-gray-900 mb-2">{discussion.title}</h2>
        <p className="text-gray-600 mb-4">{discussion.content}</p>
        <div className="flex items-center gap-4 mb-4">
          {discussion.tags.map(tag => (
            <span 
              key={tag} 
              className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-6">
          <button className="flex items-center gap-1 text-gray-600 hover:text-navy-600">
            <Heart size={18} />
            <span>{discussion.likes}</span>
          </button>
          <button className="flex items-center gap-1 text-gray-600 hover:text-navy-600">
            <MessageCircle size={18} />
            <span>{discussion.comments}</span>
          </button>
          <button className="flex items-center gap-1 text-gray-600 hover:text-navy-600">
            <Share2 size={18} />
            Share
          </button>
        </div>
      </div>
    </div>
  </div>
);

const CommunityPage = () => {
  const discussions = [
    {
      id: 1,
      author: {
        name: 'Michael Chen',
        avatar: '/api/placeholder/40/40',
        role: 'Sales Expert'
      },
      title: 'Tips for closing enterprise deals',
      content: 'I\'ve been working in enterprise sales for 5 years, and I wanted to share some key learnings...',
      likes: 124,
      comments: 45,
      tags: ['Enterprise', 'Sales Tips', 'Negotiation'],
      timestamp: '2 hours ago'
    },
    // TODO: Add more discussion data or integrate with backend API
  ];

  return (
    <div className="pl-64 pt-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto p-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Community</h1>
            <p className="text-gray-600">Connect and learn from other sales professionals</p>
          </div>
          <button className="bg-navy-600 text-white px-6 py-2 rounded-lg hover:bg-navy-700 transition-colors flex items-center gap-2">
            <MessagesSquare size={20} />
            Start Discussion
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column: Discussions */}
          <div className="lg:col-span-2 space-y-6">
            {discussions.map(discussion => (
              <DiscussionCard key={discussion.id} discussion={discussion} />
            ))}
          </div>

          {/* Right Column: Community Stats & Topics */}
          <div className="space-y-6">
            {/* Community Stats */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h2 className="text-lg font-bold text-gray-900 mb-4">Community Stats</h2>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Users size={20} className="text-navy-600" />
                    <span className="text-gray-600">Members</span>
                  </div>
                  <span className="font-medium">5,234</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <MessageCircle size={20} className="text-navy-600" />
                    <span className="text-gray-600">Discussions</span>
                  </div>
                  <span className="font-medium">1,423</span>
                </div>
              </div>
            </div>

            {/* Popular Topics */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h2 className="text-lg font-bold text-gray-900 mb-4">Popular Topics</h2>
              <div className="flex flex-wrap gap-2">
                {['Sales Strategy', 'Cold Calling', 'Negotiation', 'Client Relations', 'Sales Tools'].map(topic => (
                  <span 
                    key={topic}
                    className="text-sm text-navy-600 bg-navy-50 px-3 py-1 rounded-full cursor-pointer hover:bg-navy-100"
                  >
                    {topic}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage;